<template>
  <div id="user">
    <nav>
      <div class="userinfo">
        <el-image class="avatar" style="width: 60px; height: 60px" :src="userinfo.avatar" alt="avatar"></el-image>
        <div class="right">
          <div class="name">{{userinfo.nickname !== "" ? userinfo.nickname : userinfo.phone}}</div>
          <div class="description">您已坚持记账 {{accountingDays}} 天</div>
        </div>
      </div>
      <div class="book-current">
        <div class="bk"  v-bind:style="{ 
          'background-image': 'url(' + bookBackgroundImage() + ')',
          'color': (currentBook != null ? currentBook.background_image : '') == '' ? '#000000' : '#FFFFFF'
          }">
          <span>{{currentBook != null ? currentBook.name : ""}}</span>
        </div>
      </div>
      <div class="book-list">
          <div class="book" v-bind:class="{'active': currentBook.id == item.id}" v-for="item in books" v-bind:key="item.id" v-on:click="switchBook(item)">
            {{item.name}}
            <i v-if="currentBook.id == item.id" class="el-icon-check"></i>
          </div>
        </div>
      <div class="nav-list">
        <router-link to="/user/info">
          <i class="el-icon-user" style="margin-right: 10px;"></i>
          <span>用户资料</span>
          <i class="el-icon-arrow-right"></i>
        </router-link>
        <router-link to="/user/import">
          <i class="el-icon-upload2" style="margin-right: 10px;"></i>
          <span>账单导入</span>
          <i class="el-icon-arrow-right"></i>
        </router-link>
      </div>
      <div class="footer">
        <el-link v-on:click="home" type="text">首页</el-link>
        <el-link v-on:click="exit" type="danger">退出登录</el-link>
      </div>
    </nav>

    <div id="user-page">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<style lang="scss" scope>
@import '@/scss/public.scss';

#user {
  position: relative;
  -webkit-box-flex: 1;
  background: $color-board;

  nav {
    position: fixed;
    background: $color-white;
    width: 280px;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;

    .userinfo {
      display:-webkit-box;
      padding: 15px 20px;
      transition: background .3s;
      border-bottom: 1px solid $color-board;

      &:active {
        background: $color-board;
      }

      .right {
        -webkit-box-flex: 1;
        margin-left: 10px;

        .name {
          font-size: 16px;
          margin-top: 15px;
        }
        .description {
          font-size: 12px;
          color: $color-gray;
        }
      }
    }

    .book-current {
      height: 100px;
      padding: 15px 20px;

      .bk {
        width: 100%;
        height: 100%;
        background-color: $color-board;
        background-size: cover;

        color: $color-white;
        text-align: center;
        font-size: 22px;
        line-height: 100px;
      }
    }

    .book-list {
      padding: 0px 20px;
      padding-bottom: 10px;
      margin-bottom: 10px;
      max-height: 175px;
      height: auto;
      overflow-y:auto;
      border-bottom: 1px solid $color-board;

      .book {
        width: 100%;
        
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        transition: color .3s;

        &:active {
          color: $color-type-transfer;
        }

        &.active {
          color: $color-type-transfer;
        }
      }
    }

    .nav-list {
      a {
        display: -webkit-box;
        height: 42px;
        line-height: 42px;
        padding: 0 20px;
        font-weight: bold;
        color: $color-black;
        text-decoration: none;
        font-size: 14px;
        transition: background .3s, color .3s;

        span {
          display: block;
          -webkit-box-flex: 1;
        }

        &:active {
          color: $color-type-transfer;
        }

        &.router-link-exact-active {
          color: $color-type-transfer;
          background: $color-board;
        }
      }
    }

    .footer {
      position:absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-top: 1px solid $color-board;
      font-size: 14px;
      color: $color-gray;

      a {
        font-size: 14px;
        font-weight: normal;
        padding: 0px 10px;
      }
    }
  }

  #user-page {
    margin-left: 300px;
    height: 100%;
    overflow-y: auto;
  }
}
</style>

<script>
import { session } from '../../utils/storage'
import defaultAvatar from "@/assets/default_avatar.png"
import bk_car from "@/assets/book/bk_car.jpg";
import bk_fog from "@/assets/book/bk_fog.jpg";
import bk_forest from "@/assets/book/bk_forest.jpg";
import bk_friend from "@/assets/book/bk_friend.jpg";
import bk_galaxy from "@/assets/book/bk_galaxy.jpg";
import bk_home from "@/assets/book/bk_home.jpg";
import bk_lake from "@/assets/book/bk_lake.jpg";
import bk_love from "@/assets/book/bk_love.jpg";
import bk_sea from "@/assets/book/bk_sea.jpg";
import bk_sky from "@/assets/book/bk_sky.jpg";
import bk_tree from "@/assets/book/bk_tree.jpg";
import bk_wheat from "@/assets/book/bk_wheat.jpg";
import bk_wooden from "@/assets/book/bk_wooden.jpg";

export default {
  name: 'UserIndex',
  components: {
  },
   data() {
    return {
      bookBks: {bk_car: bk_car, bk_fog: bk_fog, bk_forest: bk_forest, bk_friend: bk_friend, bk_galaxy: bk_galaxy, bk_home: bk_home,
        bk_lake: bk_lake, bk_love: bk_love, bk_sea: bk_sea, bk_sky: bk_sky, bk_tree : bk_tree, bk_wheat: bk_wheat, bk_wooden: bk_wooden},
      userinfo: {avatar: defaultAvatar},
      books: [],
    }
  },
  mounted() {
    this.getUserInfo();
    this.getBooks();
  },
  methods: {
    getUserInfo(){
      this.$axios({
        method : "get",
        url : "/api/account/info",
      }).then(res => {
        if(res.status == 200 && res.data.status.code == 0) {
          this.userinfo = res.data.result;
        } else {
          this.$message('获取用户信息失败');
        }
      })
    },
    getBooks(){
      this.$axios({
        method : "get",
        url : "/api/book/books",
      }).then(res => {
        if(res.status == 200 && res.data.status.code == 0) {
          this.books = res.data.result;
          if(this.books.length > 0 && this.currentBook == null) {
            this.$store.commit('recevieCurrentBook', this.books[0]);
          }
        } else {
          this.$message.error('获取账本列表失败');
        }
      })
    },
    switchBook(book) {
      this.$store.commit('recevieCurrentBook', book);
    },
    bookBackgroundImage() {
      if(this.currentBook != null) {
          if(this.currentBook.background_image != "") {
            if(this.currentBook.background_image.indexOf("https") == 0) {
              return this.currentBook.background_image;
            } else {
              return this.bookBks[this.currentBook.background_image];
            }
          }
      }
    },
    exit() {
      session.del("current_book");
      this.$store.commit('receiveAccessToken', null);
      this.$store.commit('recevieCurrentBook', null);
      this.$router.replace({name: 'Home'});
    },
    home() {
      this.$router.replace({name: 'Home'});
    }
  },
  computed: {
    accountingDays() {
      if(this.userinfo.created_at == null || this.userinfo.created_at == 0) return 0;
      let now = new Date().getTime();
      return  parseInt((now - this.userinfo.created_at) / (24 * 60 * 60 * 1000));
    },
    currentBook() {
      return this.$store.state.currentBook;
    },
  },
}
</script>